export var ActivityLogLabelsMatch = /*#__PURE__*/ function(ActivityLogLabelsMatch) {
    ActivityLogLabelsMatch["Any"] = "any";
    ActivityLogLabelsMatch["All"] = "all";
    return ActivityLogLabelsMatch;
}({});
